import JwtDecode from 'jwt-decode';

import {getToken, saveToken, destroyToken} from '../services/JwtService';
import api from '@/api';
import User from '../models/User';

const token = getToken();
const initialiseUser = (token) => {
    if (token) {
        try {
            let user = new User(JwtDecode(token));
            return user;
        }
        catch (err) {
            console.error(err);
        }
    }

    return new User();
}

const initialState = {
    authenticated: false,
    user: initialiseUser(token),
    token: token || null
}

export default {
    namespaced: true,

    state: initialState,

    actions: {
        async logIn({ commit }, credentials) {
            let { userId, password } = credentials;
            let result;

            try {
                result = await api.authenticate.user(userId, password);
            }
            catch (err) {
                throw new Error('Failed to contact authentication server');
            }

            let { error, message, results } = result;

            if (error) throw new Error(message);

            let { token } = results;
            let user = new User(JwtDecode(token));
            saveToken(token);
            commit('authenticateSuccess', user);
            commit('token', token);
            return user;
        },

        async validateToken({ commit }) {  // maybe this just needs to be a token refresh function
            let token = getToken();
            if (!token) throw new Error('No token stored');

            let result;
            try {
                result = await api.authenticate.token(token);
            }
            catch (err) {
                throw new Error('Failed to contact authentication server');
            }

            let { error, message, results } = result;

            if (error) throw new Error(message);

            let user = new User(JwtDecode(token));
            commit('authenticateSuccess', user);
            commit('token', token);
            return user;
        },

        logOut({ commit }) {
            commit('logOut');
            destroyToken();
            location.href = '';
        }
    },

    mutations: {
        authenticateSuccess(state, user) {
            state.authenticated = true;
            state.user = user;
        },

        token(state, token) {
            state.token = token;
        },

        authenticateFailed(state) {
            state.authenticated = false;
            state.user = null;
        },

        logOut(state) {
            state.authenticated = false;
            state.user = null;
        }
    },

    getters: {
        isAdmin(state) {
            return state.user && state.user.isAdmin;
        },

        isHost(state) {
            let role = state.user && state.user.role;
            if (role == 'producer' || role == 'host') return true;
            return false;
        },
    }
}